import React from "react"
import Section from "./section/Section"
import Container from "../../hoc/container/Container"
import data from "../../resources/legal/privacyPolicyData"

import style from "./PrivacyPolicy.module.css"

const PrivacyPolicy = () => {
  const sectionsArray = []

  for (let section in data.sections) {
    sectionsArray.push({
      ...data.sections[section],
    })
  }

  let index = sectionsArray.map((section, index) => (
    <a href={"#" + (index + 1)} alt={`Go to ${section.title}`}>
      <h4 className={style.indexHeading}>
        {index + 1}. {section.title}
      </h4>
    </a>
  ))

  let sections = sectionsArray.map((section, index) => (
    <Section index={index + 1} title={section.title} points={section.points} />
  ))

  return (
    <main>
      <div className={style.titleWrapper}>
        <Container>
          <h1 className={style.title}>Privacy Policy</h1>
        </Container>
      </div>

      <section className={style.indexContainer}>
        <Container>{index}</Container>
      </section>

      {sections}
    </main>
  )
}

export default PrivacyPolicy
